import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Search, Scissors, BatteryCharging, Leaf } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Search,
    title: 'Paso 1 — Diagnóstico real',
    description: 'Identificás las fugas de energía en tu trabajo, estudio y vida cotidiana.',
    color: 'text-fuchsia-500',
    bg: 'bg-fuchsia-100'
  }, {
    icon: Scissors,
    title: 'Paso 2 — Corte de desgaste',
    description: 'Aprendés qué dejar de sostener sin culpa ni autoexigencia.',
    color: 'text-pink-500',
    bg: 'bg-pink-100'
  }, {
    icon: BatteryCharging,
    title: 'Paso 3 — Recuperación amable',
    description: 'Empezás a sentir más energía sin forzarte ni exigirte más.',
    color: 'text-rose-500',
    bg: 'bg-rose-100'
  }, {
    icon: Leaf,
    title: 'Paso 4 — Energía sostenible',
    description: 'Vivís con una energía que alcanza para cumplir y también para vos.',
    color: 'text-emerald-500',
    bg: 'bg-emerald-100'
  }];
  return <Section background="white" className="text-center" data-id="element-146">
      <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-12" data-id="element-147">
        ¿Cómo funciona el método?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-148">
        {steps.map((step, index) => <motion.div key={index} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:border-slate-300 transition-all text-left flex gap-6 items-start" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1
      }} viewport={{
        once: true
      }} whileHover={{
        y: -5
      }} data-id="element-149">
            <div className={`${step.bg} p-4 rounded-xl flex-shrink-0`} data-id="element-150">
              <step.icon className={`w-8 h-8 ${step.color}`} data-id="element-151" />
            </div>
            <div data-id="element-152">
              <h3 className="text-xl font-black text-slate-900 mb-2" data-id="element-153">
                {step.title}
              </h3>
              <p className="text-slate-600 text-lg leading-relaxed" data-id="element-154">
                {step.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}